import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import type { Dispatch, SetStateAction } from "react";
import {
  CreateExplorationForm,
  type CreateFormInput,
} from "../../forms/myExplorations/CreateExplorationForm";

const CreateExplorationSheet = ({
  open,
  onOpenChange,
  setExplorations,
  data,
  prefill,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  setExplorations: Dispatch<
    SetStateAction<{
      explorations: any[];
      classes: any[];
      rotations: any[];
      sessions: any[];
      teachers: any[];
    }>
  >;
  data: { rotations: any[]; sessions: any[]; teachers: any[] };
  prefill?: Partial<CreateFormInput>;
}) => {
  const onSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>Create Exploration</SheetTitle>
          <SheetDescription>Create a new exploration.</SheetDescription>
        </SheetHeader>
        <CreateExplorationForm
          key={prefill ? "prefill" : "blank"}
          onSuccess={onSuccess}
          setExplorations={setExplorations}
          data={data}
          prefill={prefill}
        />
      </SheetContent>
    </Sheet>
  );
};

export { CreateExplorationSheet };
